<script>
	import { cn } from "$lib/utils";
	let className = undefined;
	export { className as class };
</script>

<div class={cn("text-sm text-muted-foreground", className)} {...$$restProps}>
	<slot />
</div>
